if (!customElements.get('slideshow-carousel')) {
  class SlideshowCarousel extends HTMLElement {
    constructor() {
      super();

      let section = (this.section = this.dataset.section);
      this.selectors = {
        slideshowImages: `.js-slideshow-carousel-images-${section}`,
        slideshowContent: `.js-slideshow-carousel-content-${section}`
      }
  
      this.data = {
        adaptHeight: 'adaptHeight',
        autoplay: 'autoplay',
        autoplaySpeed: 'autoplaySpeed',
        minAspectRatio: 'minAspectRatio',
        minAspectRatioMobile: 'minAspectRatioMobile',
        sliderEffect: 'sliderEffect',
        showDots: 'showDots'
      }

      this.attr = {
        currentSlide: 'data-current-slide'
      }
  
      this.settings = {
        adaptHeight: this.dataset[this.data.adaptHeight] == 'true',
        autoplay: this.dataset[this.data.autoplay] == 'true',
        autoplaySpeed: parseInt(this.dataset[this.data.autoplaySpeed] || 5000),
        sliderEffect: this.dataset[this.data.sliderEffect] || 'default',
        showDots: this.dataset[this.data.showDots] == 'true'
      }

    }

    connectedCallback() {
      // Slides 2+ are rendered without src (data-deferred-src/srcset) so they don't
      // compete with slide 1 (the LCP image). Load them once the page has finished loading.
      window.SliderLoader.pageReady().then(() => this.loadDeferredImages());

      if (this.initialized) return;
      if (
        !this.querySelector(this.selectors.slideshowImages) &&
        !this.querySelector(this.selectors.slideshowContent)
      ) return;

      // The slider starts when it is near the screen and the page is ready (see SliderLoader in global.js).
      window.SliderLoader.register(this, () => this.init(), {
        target: this.querySelector(this.selectors.slideshowImages) || this.querySelector(this.selectors.slideshowContent)
      });
    }

    disconnectedCallback() {
      window.SliderLoader.unregister(this);
    }

    init() {
      if (this.initialized) return;
      this.initialized = true;
      this.loadDeferredImages();

      if (this.querySelector(this.selectors.slideshowContent)) this.setupSlideshowContent();
      if (this.querySelector(this.selectors.slideshowImages)) this.setupSlideshowImages();
      this.initSliders();
      this.syncSliders();

      // "Adapt to first image" height is set in CSS (.slideshow-carousel--adapt-ratio)
      // from first paint, so no JS height calculation is needed here any more.
    }

    loadDeferredImages() {
      // <source> elements come before their <img> in document order, so the browser
      // has the desktop srcset before it picks the image.
      this.querySelectorAll('[data-deferred-src], [data-deferred-srcset]').forEach((image) => {
        if (image.dataset.deferredSrcset) image.srcset = image.dataset.deferredSrcset;
        // Download now (still low priority) instead of keeping native lazy loading: off-screen
        // slides sit beside the visible one, so lazy images only started loading as the slide
        // moved in and showed blank until they arrived.
        if (image.tagName === 'IMG') image.loading = 'eager';
        if (image.dataset.deferredSrc) image.src = image.dataset.deferredSrc;
        image.removeAttribute('data-deferred-srcset');
        image.removeAttribute('data-deferred-src');
      });
    }

    setupSlideshowImages() {
      let settings = {
        init: false,
        loop: true,
        speed: 600,
        autoHeight: false,
        preventInteractionOnTransition: true,
        slidesPerView: 1
      };

      if (this.settings.autoplay) {
        Object.assign(settings, {
          autoplay: {
            delay: this.settings.autoplaySpeed
          }
        });
      };

      // if (this.slideshowContent) {
      //   Object.assign(settings, {
      //     thumbs: {
      //       swiper: this.slideshowContent
      //     }
      //   });
      // }

      if (this.settings.sliderEffect !== 'default') {
        if (this.settings.sliderEffect == 'fade') {
          Object.assign(settings, {
            effect: 'fade',
            fadeEffect: {
              crossFade: true
            }
          });
        }
      }

      this.slideshowImages = new Swiper(this.selectors.slideshowImages, settings);
      
    }
  
    setupSlideshowContent() {
      let settings = {
        init: false,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 600,
        slidesPerView: 1,
        autoHeight: true,
        allowTouchMove: false,
        on: {
          activeIndexChange: (slideshowContent) => {
            slideshowContent.el.setAttribute(this.attr.currentSlide, slideshowContent.activeIndex);
          }
        }
      };

      if (this.settings.showDots) {
        Object.assign(settings, {
          pagination: {
            el:'.swiper-pagination',
            clickable: true
          }
        });
      };
      
      this.slideshowContent = new Swiper(this.selectors.slideshowContent, settings);
      
    }

    syncSliders() {
      if (!this.slideshowContent || !this.slideshowImages) return;
      this.slideshowContent.controller.control = this.slideshowImages;
      this.slideshowImages.controller.control = this.slideshowContent;
    }
    
    initSliders() {
      if (this.slideshowContent) this.slideshowContent.init();
      if (this.slideshowImages) this.slideshowImages.init();

    }

  }

  customElements.define('slideshow-carousel', SlideshowCarousel);
}